import { BaseModal } from './BaseModal'

interface Props {
  isOpen: boolean
  roomName: string
  onConfirm: () => void
  onCancel: () => void
}

export const RoomInviteConfirmModal = ({
  isOpen,
  roomName,
  onConfirm,
  onCancel,
}: Props) => {
  return (
    <BaseModal
      title="Szoba meghívó"
      isOpen={isOpen}
      handleClose={onCancel}
      preventBackdropClose={true}
      zIndex={1025}
    >
      <div className="mt-4 space-y-4">
        <p className="text-gray-700 dark:text-gray-300">
          Meghívtak a{' '}
          <strong className="text-gray-900 dark:text-white">{roomName}</strong>{' '}
          szobába.
        </p>
        <p className="text-gray-600 dark:text-gray-400 text-sm">
          Szeretnél csatlakozni?
        </p>
        <div className="flex gap-3 mt-6">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-2 bg-gray-200 dark:bg-gray-600 text-gray-800 dark:text-gray-200 rounded-md hover:bg-gray-300 dark:hover:bg-gray-500"
          >
            Mégsem
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
          >
            Csatlakozás
          </button>
        </div>
      </div>
    </BaseModal>
  )
}
